var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.893,
    height: 17.205,
    viewBox: "0 0 17.893 17.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M16.45,3.937h-.043a4.894,4.894,0,0,0-4.086,2.237A4.894,4.894,0,0,0,8.235,3.937H8.192A4.863,4.863,0,0,0,3.375,8.8a10.47,10.47,0,0,0,2.056,5.708,36.03,36.03,0,0,0,6.89,6.637,36.03,36.03,0,0,0,6.89-6.637A10.47,10.47,0,0,0,21.268,8.8,4.863,4.863,0,0,0,16.45,3.937Z",
    transform: "translate(-3.375 -3.937)",
    fill: "#fe0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.12cbc7fe437eb703c8fee1a9355f9f2a.svg";
export { ForwardRef as ReactComponent };